import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import { AppBar, Box, Button, IconButton, Stack, Toolbar, Typography, Tooltip } from '@mui/material';
import Iconify from '../../components/Iconify';
import { adminLevel } from 'src/axiosLib/services/institution/admin';
import { get } from 'lodash';

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 72;

const RootStyle = styled(AppBar)(() => ({
  boxShadow: 'none',
  background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #3730a3 100%)',
  borderBottom: '1px solid rgba(99, 102, 241, 0.2)',
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3),
    marginLeft: DRAWER_WIDTH,
  },
}));

CoolDashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function CoolDashboardNavbar({ onOpenSidebar }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const [instituteName, setInstituteName] = useState('');
  const [agencyRoles, setAgencyRoles] = useState([]);

  useEffect(() => {
    adminLevel((error, data) => {
      if (!error) {
        setInstituteName(get(data, 'admin.institutionId.institutionName', 'Dashboard'));
        setAgencyRoles(get(data, 'admin.institutionId.agencyWideRoles', []));
      }
    });
  }, []);

  const switchToOld = () => {
    localStorage.setItem('dashboardMode', 'classic');
    const newPath = pathname.replace('/cool-dashboard/', '/dashboard/') + search;
    navigate(newPath);
  };

  const handleLogout = () => {
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const navBtnSx = {
    color: '#c7d2fe', fontWeight: 600, fontSize: '0.8rem', textTransform: 'none',
    borderRadius: 2, px: 1.5, minWidth: 'auto',
    '&:hover': { background: 'rgba(165,180,252,0.12)' },
  };

  return (
    <RootStyle>
      <ToolbarStyle>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: '#e0e7ff', display: { lg: 'none' } }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Typography sx={{
          fontWeight: 800, fontSize: '1.1rem', letterSpacing: -0.3,
          background: 'linear-gradient(90deg, #e0e7ff, #a5b4fc)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          display: { xs: 'none', sm: 'block' },
        }}>
          {instituteName || 'Dashboard'}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={1}>
          {agencyRoles.includes('NEW_CLASSIC_EXAM_ADMIN_DASHBOARD') && (
            <Tooltip title="Switch to Classic View">
              <IconButton onClick={switchToOld} sx={{
                color: '#a5b4fc',
                border: '1px solid rgba(165,180,252,0.3)',
                borderRadius: 2, px: 1.5,
                '&:hover': { background: 'rgba(165,180,252,0.1)' },
              }}>
                <Iconify icon="eva:swap-outline" sx={{ mr: 0.5 }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#a5b4fc' }}>Classic</Typography>
              </IconButton>
            </Tooltip>
          )}

          <Button startIcon={<Iconify icon="mdi:home-outline" />}
            onClick={() => navigate('/coolHomePage')} sx={navBtnSx}>
            Home
          </Button>

          <Button startIcon={<Iconify icon="mdi:logout" />}
            onClick={handleLogout}
            sx={{ ...navBtnSx, color: '#fca5a5', '&:hover': { background: 'rgba(239,68,68,0.12)' } }}>
            Logout
          </Button>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
